var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar android app aplication phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_android_app_aplication_phone",
    "data-name": "calendar android app aplication phone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.56,8.47a8,8,0,0,0-7-7,64.29,64.29,0,0,0-15.06,0,8,8,0,0,0-7,7,64.29,64.29,0,0,0,0,15.06,8,8,0,0,0,7,7,64.29,64.29,0,0,0,15.06,0,8,8,0,0,0,7-7A64.29,64.29,0,0,0,30.56,8.47ZM8.7,3.42a63.65,63.65,0,0,1,14.6,0A6,6,0,0,1,27.56,6H4.44A6,6,0,0,1,8.7,3.42ZM28.58,23.3a6,6,0,0,1-5.28,5.28,63.65,63.65,0,0,1-14.6,0A6,6,0,0,1,3.42,23.3a63.65,63.65,0,0,1,0-14.6A5.44,5.44,0,0,1,3.57,8H28.43a5.44,5.44,0,0,1,.15.7A63.65,63.65,0,0,1,28.58,23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,11H7a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H9a2,2,0,0,0,2-2V13A2,2,0,0,0,9,11ZM7,15V13H9v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,11H15a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,17,11Zm-2,4V13h2v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,11H23a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V13A2,2,0,0,0,25,11Zm-2,4V13h2v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,19H7a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H9a2,2,0,0,0,2-2V21A2,2,0,0,0,9,19ZM7,23V21H9v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,19H23a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2V21A2,2,0,0,0,25,19Zm-2,4V21h2v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.71,19.29a1,1,0,0,0-1.42,0L16,20.59l-1.29-1.3a1,1,0,0,0-1.42,1.42L14.59,22l-1.3,1.29a1,1,0,0,0,1.42,1.42L16,23.41l1.29,1.3a1,1,0,0,0,1.42-1.42L17.41,22l1.3-1.29A1,1,0,0,0,18.71,19.29Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCal);
export default __webpack_public_path__ + "static/media/newCal.ce21ec28b94addf910c3ac3a285207fa.svg";
export { ForwardRef as ReactComponent };